import { useState, useEffect, Dispatch, SetStateAction } from 'react';

type Response<T> = [T, Dispatch<SetStateAction<T>>];

const persistedStateNamePrefix = '@persisted:';

function usePersistedState<T>(key: string, initialState: T): Response<T> {
  const [state, setState] = useState(() => {
    const storageValue = localStorage.getItem(
      `${persistedStateNamePrefix}${key}`,
    );

    if (storageValue) {
      return JSON.parse(storageValue);
    }

    return initialState;
  });

  useEffect(() => {
    localStorage.setItem(
      `${persistedStateNamePrefix}${key}`,
      JSON.stringify(state),
    );
  }, [key, state]);

  return [state, setState];
}

export default usePersistedState;
